import type {
  BusinessDocumentsFormValues,
  BusinessDocumentType,
} from '~domains/partner-application/entities/application/model';

type BusinessDocumentDateField = {
  name: Extract<keyof BusinessDocumentsFormValues, 'dtiCertificateExpiryDate'>;
  label: string;
};

type BusinessDocumentSection = {
  documentType: BusinessDocumentType;
  title: string;
  description?: string;
  required: boolean;
  multiple: boolean;
  /** Extra date field */
  dateField?: BusinessDocumentDateField;
};

export const businessDocumentSections: BusinessDocumentSection[] = [
  {
    documentType: 'BUSINESS_PERMIT',
    title: "Business Permit / Mayor's Permit",
    required: true,
    multiple: true,
  },
  {
    documentType: 'BIR_CERTIFICATE_OR_FORM2303',
    title: 'BIR Certificate of Registration or Form 2303',
    required: true,
    multiple: true,
  },
  {
    documentType: 'DTI_CERTIFICATE',
    title: 'DTI Certificate of Business Name Registration',
    required: true,
    multiple: true,
    dateField: {
      name: 'dtiCertificateExpiryDate',
      label: 'DTI Certificate of Business Name Registration expiry date',
    },
  },
  {
    documentType: 'OTHER',
    title: 'Other supporting documents (if any)',
    description:
      'Lease contract, utility bills, barangay clearance, supplier/customer contracts, etc.',
    required: false,
    multiple: true,
  },
];

export const FILE_OPTIONS = {
  allowedExtensions: ['pdf', 'jpeg', 'jpg', 'png'],
  maxSize: 10 * 1024 * 1024, // 10MB
};
